export default {
	// 根地址，协议相对地址可随浏览器 http/https 自适应
	host: "//shop.api.dev.com",

	// 请求地址
	baseUrl: "//shop.api.dev.com/admin/",
	oss: {
		website: "https://suwa3d-test.oss-cn-shanghai.aliyuncs.com",
		"3dview": "https://suwa3d-test.oss-cn-shanghai.aliyuncs.com",
		webwechat: "https://suwa3d-test.oss-cn-shanghai.aliyuncs.com",
		securedata: "https://suwa3d-test.oss-cn-shanghai.aliyuncs.com",
		shop: "https://suwa3d-test.oss-cn-shanghai.aliyuncs.com"
	},
	// websocket.ts 会根据页面协议自动把 ws:// 切换为 wss://
	msgWebsocket: {
		WEBSOCKETADDRESS: "ws://shop.api.dev.com"
	},
	weightWs: "ws://localhost:10999/ws",
	menuIgnore: [],
	watermask: {
		title: "速哇3D真人手办"
	}
};
